import { BaseModel } from "./baseModel";

export class SpeciSummaryModel extends BaseModel {
    public speciId:number;
    public speciNo:number;
    public clipReference:string;
    public noOfLine:number;
    public traceabilityStatus:string;
    public weight:number;
}